<template>
    <pg-page title="Private Gym - Aanmelden"
             header="Abonnement voor een bestaand account"
             id="subscription-attach"
             :footer="false"
    >

        <div class="mx-auto mt-4">
            <form novalidate>
                <div class="row g-3  justify-content-center">
                    <div class="col-sm-6 text-center order-1">
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="card-header py-3">
                                <h4 class="my-0 fw-normal">Introductie</h4>
                            </div>
                            <div class="card-body">
                                <h1 class="card-title pricing-card-title">€9,99<small class="text-muted fw-light">/wk</small></h1>
                                <ul class="list-unstyled mt-3 mb-4">
                                    <li>Dagelijks reserveren</li>
                                    <li>24/7 toegang via de app</li>
                                    <li>Altijd een eiland voor jezelf</li>
<!--                                    <li>Gratis personal training intro</li>-->
                                </ul>
                            </div>
                        </div>
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="row g-2 m-2 mb-3">
                                <div class="form-floating">
                                    <input v-model="email" type="email"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.email,
                                                    'is-valid': typeof errors.email === 'undefined' && wasValidated,
                                                }"
                                           id="email" placeholder="Email"  name="email" >
                                    <label for="email" class="form-label">Email van je account <span class="text-muted">*</span></label>
                                    <div class="invalid-feedback">
                                        {{ errors.email }}
                                    </div>
                                </div>
                                <div :class="'m-1 mt-3 form-check ' + (!legal && submitted ? ' text-danger fw-bold' : '')">
                                    <input v-model="legal" class="form-check-input" type="checkbox">
                                    <small class="form-check-label">
                                        Ik ben akkoord met de <a href="/legal/algemene-voorwaarden">Algemene voorwaarden</a> en <a href="/legal/privacy-policy">Privacy policy</a>
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="card  text-dark bg-warning mb-2 rounded-3 shadow-sm">
                            <div class="m-2">
                                Je doet hierna ter verificatie een betaling van €9.99 voor de eerste week. Je wekelijkse afschrijvingen starten pas 7 dagen <em>na</em> je eerste training.
                            </div>
                        </div>
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="m-2">
                                <button @click.prevent="send" type="button" class="w-100 btn btn-lg btn-primary" :disabled="loading">
                                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Word nu lid
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../../../Components/PgPage";
import ContactModal from "../../../Components/Contact/ContactModal";
import axios from "axios";
export default {
    components: {ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            loading: false,
            wasValidated: false,
            errors: {},
            submitted: false,

            showFormModal: false,
            email: '',
            legal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        console.log(process.env.MIX_API_URL);
    },

    methods: {
        send() {
            this.submitted = true;
            if(!this.legal) {
                return;
            }

            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;

            window.axios.post(process.env.MIX_API_URL + '/api/v1/subscription/attach', {
                email: this.email,
            })
                .then(function (response) {
                    vm.wasValidated = true;
                    let paymentLink = response.data.data;
                    window.location.href = paymentLink;
                })
                .catch(function (error) {
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                });
        },
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
    #lid-worden label {
        font-weight: bold;
        color: red;
    }
</style>
